import {Translation} from "./lang";

export const Pages: any = {
    home: {
        index: 0,
        path: '/',
        navigateTo: '/ceo',
        navigateBack: '/contact',
        title: Translation.get('navigation.home'),
        colorMatrix: ['#3d58ff', '#38bbff'],
        triangles: {
            first: {
                xPercentage: .1,
                yPercentage: .5,
                color: '#4fce78',
                rotate: 40,
                scalePercentage: 2
            },
            second: {
                xPercentage: 1.05,
                yPercentage: .5,
                color: '#ff359b',
                rotate: -15,
                scalePercentage: 4
            },
            third: {
                xPercentage: .5,
                yPercentage: 1.1,
                color: '#33acdf',
                rotate: 50,
                scalePercentage: 6
            }
        }
    },
    intro: {
        index: 1,
        path: '/ceo',
        navigateTo: '/cto',
        navigateBack: '/',
        title: Translation.get('navigation.ceo'),
        colorMatrix: ['#965dff', '#3889ff'],
        triangles: {
            first: {
                xPercentage: 0.05,
                yPercentage: -0.02,
                color: '#33acdf',
                rotate: 40,
                scalePercentage: 4
            },
            second: {
                xPercentage: .8,
                yPercentage: .15,
                color: '#ff5e20',
                rotate: -35,
                scalePercentage: 2.5
            },
            third: {
                xPercentage: .1,
                yPercentage: 1,
                color: '#ff359b',
                rotate: -25,
                scalePercentage: 4
            }
        }
    },
    applications: {
        index: 2,
        path: '/cto',
        navigateTo: '/references',
        navigateBack: '/ceo',
        title: Translation.get('navigation.cto'),
        colorMatrix: ['#3889ff', '#01eacc'],
        triangles: {
            first: {
                xPercentage: .3,
                yPercentage: 0,
                color: '#ff5e20',
                rotate: -15,
                scalePercentage: 3.5
            },
            second: {
                xPercentage: .92,
                yPercentage: 1,
                color: '#33acdf',
                rotate: -15,
                scalePercentage: 4
            },
            third: {
                xPercentage: .2,
                yPercentage: 0.9,
                color: '#d2215a',
                rotate: 70,
                scalePercentage: 3
            }
        }
    },
    references: {
        index: 3,
        path: '/references',
        navigateTo: '/marketing',
        navigateBack: '/cto',
        title: Translation.get('navigation.references'),
        colorMatrix: ['#01eacc', '#29d166'],
        triangles: {
            first: {
                xPercentage: .03,
                yPercentage: 0.2,
                color: '#33acdf',
                rotate: -40,
                scalePercentage: 2
            },
            second: {
                xPercentage: .8,
                yPercentage: .07,
                color: '#ffd429',
                rotate: 40,
                scalePercentage: 3
            },
            third: {
                xPercentage: .9,
                yPercentage: 1.05,
                color: '#ec5c25',
                rotate: -25,
                scalePercentage: 3
            }
        }
    },
    marketing: {
        index: 4,
        path: '/marketing',
        navigateTo: '/team',
        navigateBack: '/references',
        title: Translation.get('navigation.marketing'),
        colorMatrix: ['#ffd257', '#fc4a1a'],
        triangles: {
            first: {
                xPercentage: .09,
                yPercentage: 0.3,
                color: '#ff359b',
                rotate: 45,
                scalePercentage: 2.3
            },
            second: {
                xPercentage: .5,
                yPercentage: -0.05,
                color: '#ff5e20',
                rotate: -45,
                scalePercentage: 3
            },
            third: {
                xPercentage: .85,
                yPercentage: 1.05,
                color: '#33acdf',
                rotate: 45,
                scalePercentage: 4.5
            }
        }
    },
    team: {
        index: 5,
        path: '/team',
        navigateTo: '/outsourcing',
        navigateBack: '/marketing',
        title: Translation.get('navigation.team'),
        colorMatrix: ['#9f01ea', '#c80048'],
        triangles: {
            first: {
                xPercentage: 0.03,
                yPercentage: 0.3,
                color: '#33acdf',
                rotate: 45,
                scalePercentage: 2.3
            },
            second: {
                xPercentage: .8,
                yPercentage: -0.05,
                color: '#ff5e20',
                rotate: -45,
                scalePercentage: 3
            },
            third: {
                xPercentage: .9,
                yPercentage: 1.02,
                color: '#4fce78',
                rotate: 40,
                scalePercentage: 4.5
            }
        },
        content: [
            {
                title: 'PHP',
                skills: [
                    'PHP 7',
                    'Symfony 3/4',
                    'Laravel',
                    'Yii 2',
                    'Doctrine',
                    'Redis',
                    'MySQL',
                    'MariaDB',
                    'PgSQL',
                    'Behat',
                    'Codeception',
                    'Eloquent',
                    'Memcached',
                    'PHP Mess Detector',
                    'PHP CodeSniffer',
                    'Twig'
                ]
            },
            {
                title: 'C#',
                skills: [
                    'ASP.NET',
                    '.NET Core',
                    'Entity Framework',
                    'MSSQL',
                    'Azure',
                    'Azure ML',
                    'ML.NET',
                    'WPF',
                    'UWP',
                    'Razor',
                    'N/XUnit',
                    'MSTest'
                ]
            },
            {
                title: 'Frontend',
                skills: [
                    'React',
                    'React Native',
                    'Redux',
                    'Ngx',
                    'RxJs',
                    'Immutable',
                    'Websocket',
                    'Socket.io',
                    'P2P',
                    'SIP Protocol',
                    'D3',
                    'PIXIJS 4',
                    'WebGL',
                    'Canvas',
                    'Flow',
                    'ScSS',
                    'Pug',
                    'ES6',
                    'Typescript'
                ]
            },
            {
                title: 'NodeJS',
                skills: [
                    'Typescript',
                    'Express',
                    'Mongo',
                    'Mongoose',
                    'TypeORM',
                    'Kifly2',
                    'Websocket',
                    'Socket.io',
                    'WebGL Prerenderer',
                    'Kademlia',
                    'P2P',
                    'Native bindings in c++',
                    'Hadoop',
                    'AWS apis',
                    'Google & etc apis',
                    'Microservice',
                    'Pug',
                    'Redis',
                    'Memcached',
                    'Immutable'
                ]
            },
            {
                title: 'Sitebuilder',
                skills: [
                    'HTML 5',
                    'ScSS',
                    'Responsive',
                    'Bootstrap',
                    'Material Design',
                    'jQuery',
                    'Gulp',
                    'Webpack'
                ]
            },
            {
                title: 'UI/UX Designer',
                skills: [
                    'Sketch',
                    'Adobe XD',
                    'Adobe Illustrator',
                    'Adobe Photoshop',
                    'Zeplin',
                    'Logó',
                    'Website',
                    'Portal',
                    'ERP design'
                ]
            },
            {
                title: 'Unity Expert',
                skills: [
                    'Unity',
                    'AR/VR',
                    'Games and apps',
                    'Training',
                    'Consulting',
                    'Education'
                ]
            },
            {
                title: 'Dev Ops',
                skills: [
                    'AWS',
                    'Docker',
                    'Nginx',
                    'Apache',
                    'Git',
                    'Debian',
                    'Networking',
                    'Jenkins',
                    'CircleCI',
                    'Redis',
                    'Memcached',
                    'NodeJs',
                    'Kubernetes',
                    'Azure',
                    'HAProxy',
                    'Apache Hadoop',
                    'Apache Tika',
                    'Apache Solr',
                    'Elasticsearch',
                    'Load Balancing'
                ]
            }
        ]

    },
    outsourcing: {
        index: 6,
        path: '/outsourcing',
        navigateTo: '/founders',
        navigateBack: '/team',
        title: Translation.get('navigation.outsourcing'),
        colorMatrix: ['#07295b', '#35004e'],
        triangles: {
            first: {
                xPercentage: 0.08,
                yPercentage: -0.02,
                color: '#4fce78',
                rotate: 40,
                scalePercentage: 3
            },
            second: {
                xPercentage: 1.03,
                yPercentage: .5,
                color: '#33acdf',
                rotate: -15,
                scalePercentage: 3
            },
            third: {
                xPercentage: .1,
                yPercentage: 1,
                color: '#d2215a',
                rotate: 70,
                scalePercentage: 3
            }
        }
    },
    about: {
        index: 7,
        path: '/founders',
        navigateTo: '/contact',
        navigateBack: '/outsourcing',
        title: Translation.get('navigation.founders'),
        colorMatrix: ['#fc4a1a', '#c80048'],
        triangles: {
            first: {
                xPercentage: 1,
                yPercentage: 0.25,
                color: '#4fce78',
                rotate: 40,
                scalePercentage: 2.5
            },
            second: {
                xPercentage: 0.8,
                yPercentage: .55,
                color: '#ff5e20',
                rotate: 75,
                scalePercentage: 1.5
            },
            third: {
                xPercentage: .1,
                yPercentage: .7,
                color: '#33acdf',
                rotate: 70,
                scalePercentage: 2
            }
        }
    },
    contact: {
        index: 8,
        path: '/contact',
        navigateTo: '/',
        navigateBack: '/founders',
        title: Translation.get('navigation.contact'),
        colorMatrix: ['#3889ff', '#965dff'],
        triangles: {
            first: {
                xPercentage: 0.01,
                yPercentage: 0.3,
                color: '#ff359b',
                rotate: 30,
                scalePercentage: 4
            },
            second: {
                xPercentage: 1,
                yPercentage: .2,
                color: '#ffd429',
                rotate: 45,
                scalePercentage: 2
            },
            third: {
                xPercentage: .8,
                yPercentage: 1,
                color: '#ff5e20',
                rotate: -10,
                scalePercentage: 2.5
            }
        }
    }
};
